import { ReactNode } from "react";
import { cx } from "utils";


export const Section = ({children, className}: {children: ReactNode | ReactNode[], className?: string}) => {
  return (<div className={cx("flex flex-row flex-wrap gap-12", className)}>
    {children}
  </div>);
}
